// extracted by mini-css-extract-plugin
export default {"teamSection":"team_teamSection__7-LJT","teamTitle":"team_teamTitle__2qUJ6","teamContainer":"team_teamContainer__8JFnj"};